export const generateChart = (productionsProgression, startDate, endDate, productionPlan) => {
	// removing the adjustment to current localTime zone - setting to midnight
	const formattedStartDate = new Date(new Date(startDate).setHours(0, 0, 0, 0));
	const formattedEndDate = new Date(new Date(endDate).setHours(0, 0, 0, 0));

	return {
		data: {
			labels: [
				formattedStartDate,
				...productionsProgression.map((pp) => new Date(pp.productionDate)),
				formattedEndDate,
			],
			datasets: [
				{
					label: 'Vývoj produkce',
					data: [0, ...productionsProgression.map((pp) => pp.production)],
					borderColor: '#0173ff',
					fill: false,
					pointRadius: 0,
					pointHoverBorderWidth: 0.5,
					pointHitRadius: 0,
					pointHoverBackgroundColor: 'white',
					pointBackgroundColor: '#0173ff',
				},
				{
					label: 'Plánovaná produkce',
					data: [productionPlan, ...productionsProgression.map(() => productionPlan), productionPlan],
					borderColor: '#d70004',
					borderDash: [5, 5],
					pointRadius: 0,
					pointHoverRadius: 0,
					pointHoverBorderWidth: 0,
					pointHitRadius: 0,
					pointBorderWidth: 0,
				},
			],
		},
		options: {
			maintainAspectRatio: false,
			responsive: true,
			hover: {
				mode: 'nearest',
				intersect: false,
			},
			legend: {
				display: false,
			},
			title: {
				display: false,
			},
			plugins: {
				legend: {
					display: false,
				},
				title: {
					display: false,
				},
				tooltip: {
					enabled: true,
					filter: (tooltipItem) => tooltipItem.datasetIndex === 0,
					callbacks: {
						title: (tooltipItem) => {
							if (tooltipItem[0]) {
								return `${tooltipItem[0].formattedValue} Kč`;
							}
							return null;
						},
						label: () => null,
					},
				},
			},
			scales: {
				x: {
					type: 'time',
					time: {
						unit: 'week',
						displayFormats: {
							week: 'dd. MM.',
						},
						isoWeekday: true,
					},
					ticks: {
						display: true,
						minRotation: 90,
					},
					grid: {
						display: true,
					},
				},
				y: {
					display: true,
					title: {
						display: true,
						text: 'Vývoj produkce',
					},
					ticks: {
						display: false,
					},
					grid: {
						display: true,
					},
				},
			},
			interaction: {
				intersect: false,
				mode: 'nearest',
			},
		},
	};
};
